import dayjs, {Dayjs} from 'dayjs';

export const dayJsNullHandler = ({
  t,
  returnVal = null,
  format = 'MM/DD/YYYY',
}: {
  t: Dayjs | string | null | undefined;
  returnVal?: string | null;
  format?: string;
}): string | null => {
  if (!t || !dayjs(t).isValid()) {
    return returnVal;
  }

  return dayjs(t).format(format);
};
